import React from 'react'
import FileViewer from 'components/FileViewer/FileViewer'
import styles from './Dialog.module.sass'
const FileDialog = (props) => {
	const { className, data } = props

	return (
		<div className={`${styles['viewer-root'] || ''} ${className || ''}`}>
			<form>
				<FileViewer className={styles['file-viewer']} file={data} />
			</form>
		</div>
	)
}

export default FileDialog
